module.exports = __webpack_public_path__ + "static/media/task-promotional.7f57dedd.svg";